import { usePermissionsStore } from '@/stores/permissions';
import { useToastStore } from '@/stores/toast';

const permissionDirective = {
  mounted(el, binding) {
    const permissionsStore = usePermissionsStore();
    const requiredPermission = binding.value;

    const toast = useToastStore();

    if (
      requiredPermission &&
      !permissionsStore.hasPermission(requiredPermission)
    ) {
      const rolesWithPermission =
        permissionsStore.getRolesWithPermission(requiredPermission);
      el.setAttribute('data-no-permission', true);

      // main.css is adding classes based on data-no-permission attribute

      if (el.classList.contains('menu-item')) {
        el.classList.add('dark:!bg-surface-800');
      }
      el.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();

          const formattedRoles = rolesWithPermission
            .map(
              (role) =>
                role.charAt(0).toUpperCase() + role.slice(1).toLowerCase()
            )
            .join('/');

          toast.add({
            severity: 'error',
            detail: `You don't have permissions to do this. Ask an ${formattedRoles} teammate to help out.`,
            life: 3000,
          });
        },
        true
      );
    }
  },
};
export default permissionDirective;
